import { useQuery, useMutation } from '@tanstack/vue-query'
import { httpRequest } from '@shared/api/httpRequests'

/**
 * @constant {string} BASE_URL Base URL path
 */
export const BASE_URL = '/dashboard/api/v1'

/**
 * @constant {Object.<string:string>} API Map of API CRUD methods and their relative URLs (not including BASE_URL)
 */
export const API = {
  GET_CHARTS_DATA: '/charts',
  GET_OUTSTANDING_ACTIONS: '/outstandingActions',
}

/**
 * @constant {Object.<string:string>} DASHBOARD_API Map of API CRUD methods and their URLs (including BASE_URL)
 */
export const DASHBOARD_API = Object.fromEntries(
  Object.entries(API).map(([key, val]) => [key, `${BASE_URL}${val}`]),
)

export function getChartsData (queryOptions = {}) {
  const queryKey = [API.GET_CHARTS_DATA]
  const queryFn = async () => await httpRequest({
    baseURL: BASE_URL,
    url: API.GET_CHARTS_DATA,
  })
  return useQuery({ queryKey, queryFn, ...queryOptions })
}

export function getChartsDataWithFilters (mutationOptions = {}) {
  const mutationFn = async ({ params = {} }) => {
    const response = await httpRequest({
      method: 'POST',
      baseURL: BASE_URL,
      url: API.GET_CHARTS_DATA,
      data: params,
    })

    return response?.data || response
  }

  return useMutation({ mutationFn, ...mutationOptions })
}

export function getOutstandingActions (queryOptions = {}) {
  const queryKey = [API.GET_OUTSTANDING_ACTIONS]
  const queryFn = async () => await httpRequest({
    baseURL: BASE_URL,
    url: API.GET_OUTSTANDING_ACTIONS,
  })
  return useQuery({ queryKey, queryFn, ...queryOptions })
}

export function getSiteScopePresetCounts (siteScope, queryOptions = {}) {
  const suburl = `siteScope/${siteScope}/counts`
  const queryKey = [suburl]
  const queryFn = async () => await httpRequest({
    baseURL: BASE_URL,
    url: suburl,
  })
  return useQuery({ queryKey, queryFn, ...queryOptions })
}
